import { render, staticRenderFns } from "./returnorder.vue?vue&type=template&id=15525336&"
import script from "./returnorder.vue?vue&type=script&lang=js&"
export * from "./returnorder.vue?vue&type=script&lang=js&"
import style0 from "./returnorder.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports